<template>
<div>
    <accounting-books-receipt-form :subsidiaryLedgerId="subsidiaryLedgerId" :year="year" :companyId="companyId" :getAccountingBooksReceiptList="getAccountingBooksReceiptList" :getAccountingBooksList="getAccountingBooksList" ref="accountingBooksReceiptFormModal"></accounting-books-receipt-form>
    <b-row class="custom-search">
        <b-col class="col-md-3 mb-1">
            <label for="accountingTransactionType-input">{{ $t('accountingBooksReceipt.accounting_transaction_type') }}</label>
            <b-form-select id="accountingTransactionType-input" v-model="accountingTransactionTypeSelect" size="sm" value-field="id" text-field="name" :options="accountingTransactionTypeOption" @change="getAccountingBooksReceiptList()" />
        </b-col>
        <b-col class="col-md-3 mb-1">
            <label for="date-start-input">{{ $t('accountingBooksReceipt.date_start') }}</label>
            <CustomDatePicker :datePickerValidateOption="0" name="date-start-input" v-model="dateStart" @input="getAccountingBooksReceiptList()"></CustomDatePicker>
        </b-col>
        <b-col class="col-md-3 mb-1">
            <label for="date-end-input">{{ $t('accountingBooksReceipt.date_end') }}</label>
            <CustomDatePicker :datePickerValidateOption="0" name="date-end-input" v-model="dateEnd" @input="getAccountingBooksReceiptList()"></CustomDatePicker>
        </b-col>
        <b-col class="col-md-3 mb-1 custom-search d-flex justify-content-end">
            <div class="d-flex align-items-center">
                <b-button style="float:right;" class="ml-05" size="sm" variant="outline-primary" @click="getAccountingBooksReceiptList()">{{ $t('others.list') }}</b-button>
                <b-button style="float:right; border-color:#6B7280; color:#374151;" class="ml-05" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('accountingBooksReceipt.add') }}</b-button>
                <b-button style="float:right; border-color:#6B7280; color:#374151;" class="ml-05" size="sm" variant="outline-secondary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
            </div>
        </b-col>
    </b-row>
    <b-row class="custom-search">
        <b-col class="col-md-3 mb-1">
            <label for="document-date-start-input">{{ $t('accountingBooksReceipt.document_date_start') }}</label>
            <CustomDatePicker :datePickerValidateOption="0" name="document-date-start-input" v-model="documentDateStart" @input="getAccountingBooksReceiptList()" ></CustomDatePicker>
        </b-col>
        <b-col class="col-md-3 mb-1">
            <label for="document-date-end-input">{{ $t('accountingBooksReceipt.document_date_end') }}</label>
            <CustomDatePicker :datePickerValidateOption="0" name="document-date-end-input" v-model="documentDateEnd" @input="getAccountingBooksReceiptList()" ></CustomDatePicker>
        </b-col>
        <b-col class="col-md-3 mb-1">
            <label for="employee-input">{{ $t('accountingBooksReceipt.employee') }}</label>
            <b-form-select id="employee-input" v-model="employeeSelect" size="sm" value-field="id" text-field="name" :options="employeeOption" @change="getAccountingBooksReceiptList()"/>
        </b-col>
        <b-col class="col-md-3 mb-1">
            <label for="reference-input">{{ $t('accountingBooksReceipt.reference') }}</label>
            <b-form-input id="reference-input" size="sm" v-model="reference" v-on:keyup.enter="getAccountingBooksReceiptList()" :placeholder="$t('accountingBooksReceipt.reference')" type="text" class="d-inline-block" />
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="accountingBooksReceiptTable" ref="accountingBooksReceiptTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
            enabled: true,
            externalQuery: searchTerm
          }" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, 
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true,
            selectAllByGroup: true,
          }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'documentDate'" class="text-nowrap">
                {{ $t('accountingBooksReceipt.document_date') }}
            </span>
            <span v-else-if="props.column.field === 'number'" class="text-nowrap">
                {{ $t('accountingBooksReceipt.number') }}
            </span>
            <span v-else-if="props.column.field === 'reference'" class="text-nowrap">
                {{ $t('accountingBooksReceipt.reference') }}
            </span>
            <span v-else-if="props.column.field === 'description'" class="text-nowrap">
                {{ $t('accountingBooksReceipt.description') }}
            </span>
            <span v-else-if="props.column.field === 'accountingTransactionType'" class="text-nowrap">
                {{ $t('accountingBooksReceipt.accounting_transaction_type') }}
            </span>
            <span v-else-if="props.column.field === 'amount'" class="text-nowrap">
                {{ $t('accountingBooksReceipt.amount') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Description -->
            <span v-if="props.column.field === 'description'">
                <span class="wh-clamp-2" v-b-tooltip.hover="{ title: props.row.description, customClass: 'wh-tooltip' }">{{ props.row.description }}</span>
            </span>
            <!-- Column: Process -->
            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'CopyIcon', label: $t('accountingBooksReceipt.copy'), handler: () => copy(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', show: props.row.sequence == 0, handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','25','50','100']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getAccountingBooksReceiptList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        getAccountingBooksList: {
            type: Function
        },
        subsidiaryLedgerId: {
            type: Number
        },
        year: {
            type: Number,
            default: null
        },
        companyId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            total: 0,
            pageLength: 50,
            dir: false,
            pageNo: 1,
            dateStart: null,
            dateEnd: null,
            documentDateStart: null,
            documentDateEnd: null,
            reference: "",
            employeeSelect: 0,
            employeeOption: [],
            accountingTransactionTypeSelect: 0,
            accountingTransactionTypeOption: [],
            columns: [{
                    label: this.$t('accountingBooksReceipt.document_date'),
                    field: `documentDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('accountingBooksReceipt.number'),
                    field: `number`,
                },
                {
                    label: this.$t('accountingBooksReceipt.reference'),
                    field: `reference`,
                },
                {
                    label: this.$t('accountingBooksReceipt.description'),
                    field: `description`,
                },
                {
                    label: this.$t('accountingBooksReceipt.accounting_transaction_type'),
                    field: `accountingTransactionType`,
                },
                {
                    label: this.$t('accountingBooksReceipt.amount'),
                    field: `amount`,
                    formatFn: this.$formatAmount,
                    tdClass: 'text-right',
                    thClass: 'text-right'
                },
                {
                    label: '',
                    field: 'process',
                    width: '8em',
                    sortable: false
                },
            ],
            rows: [],
            searchTerm: '',
            accountingTransactionToCopy : [],
            accountingTransactionDetailListToCopy :[],
            searchDebounce: null,
            requestSeq: 0
        }
    },
    mounted() {
        //this.dateEnd = new Date().toJSON()
        //This code closed For STOCK-2018
        this.getAccountingBooksReceiptList()
    },
    watch: {
        reference() {
            this.debouncedSearch()
        }
    },
    methods: {
        debouncedSearch() {
            clearTimeout(this.searchDebounce)
            this.searchDebounce = setTimeout(() => {
                if (this.pageNo !== undefined) this.pageNo = 1
                this.getAccountingBooksReceiptList()
            }, 300)
        },
        async getInfo(id) {
            this.$refs.accountingBooksReceiptFormModal.showInfo(id)
        },
        getAccountingBooksReceiptList() {
            const requestSeq = ++this.requestSeq
            const controller = {
                name: 'AccountingTransaction'
            }
            const data = {
                subsidiaryLedgerId: this.subsidiaryLedgerId,
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                dateStart: this.dateStart,
                dateEnd: this.dateEnd,
                documentDateStart: this.documentDateStart,
                documentDateEnd: this.documentDateEnd,
                reference: this.reference,
                employeeId: this.employeeSelect,
                accountingTransactionTypeId: this.accountingTransactionTypeSelect,
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                // Daha yeni bir istek gonderildiyse bu yanit bayattir, uygulanmaz
                if (requestSeq !== this.requestSeq) return
                this.total = response.data.total
                if (response.data.resultStatus == true) {
                    this.rows = response.data.accountingTransactionList
                    this.employeeOption = response.data.employeeList
                    this.accountingTransactionTypeOption = response.data.accountingTransactionTypeList
                    this.employeeOption.splice(0, 0, this.$nullSelected())
                    this.accountingTransactionTypeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            let controller = {
                name: 'AccountingTransaction'
            }
            let data = {
                subsidiaryLedgerId: this.subsidiaryLedgerId,
                pageLength: this.total,
                pageNo: 1,
                dateStart: this.dateStart,
                dateEnd: this.dateEnd,
                documentDateStart: this.documentDateStart,
                documentDateEnd: this.documentDateEnd,
                reference: this.reference,
                employeeId: this.employeeSelect,
                accountingTransactionTypeId: this.accountingTransactionTypeSelect,
            }
            let payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    const controller = {
                        name: 'AccountingTransaction',
                        actionName: 'CanExport'
                        }
                        const data = {
                            columnList: this.columns,
                            DataList: response.data.accountingTransactionList
                        }
                        const payload = {
                            data: data,
                            controller: controller
                        }
                        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                            if (response.data.resultStatus == true) {
                                this.$downloadFile("AccountingBooksReceipt", response.data.base64, 'xlsx')
                            } else {
                                this.$WarningAlert(response.data.resultMessage)
                            }
                        })
                    
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        copy(id) {
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'CopyAccountingTransactionWithDetails'
            }
            const data = {
                id: id,
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                        this.$refs.accountingBooksReceiptFormModal.showInfo(0,response.data)
                        //DetailList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async deleted(data) {
            const count = data.countOfAccountingTransactionDetail
            data = {
                id: data.id
            }
            const controller = {
                name: 'AccountingTransaction'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$PrivateConfirm(this.$t("accountingBooksReceipt.delete_confirmation_header"),count + this.$t("accountingBooksReceipt.confirm_delete_message"), "warning", this.$t("others.reset"), this.$t("others.cancel_title")).then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getAccountingBooksReceiptList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
